var map = {
	"./bread-day.svg": "tWEE",
	"./bread-morning.svg": "WRIm",
	"./bread-night.svg": "ges5",
	"./cake-day.svg": "lQeE",
	"./cake-morning.svg": "wDXv",
	"./cake-night.svg": "h5Cn",
	"./fish-day.svg": "nr8Y",
	"./fish-morning.svg": "4qUB",
	"./fish-night.svg": "Ohwi",
	"./general-day.svg": "jHgl",
	"./general-morning.svg": "HETV",
	"./general-night.svg": "Mn1O",
	"./hot-meal-day.svg": "FWxI",
	"./hot-meal-morning.svg": "D1DP",
	"./hot-meal-night.svg": "oyhs",
	"./salad-day.svg": "y04+",
	"./salad-morning.svg": "vUsn",
	"./salad-night.svg": "jm2Q",
	"./smoothie-day.svg": "WvMh",
	"./smoothie-morning.svg": "DcBL",
	"./smoothie-night.svg": "oNvw",
	"./soup-day.svg": "EIXp",
	"./soup-morning.svg": "jnmv",
	"./soup-night.svg": "Kkd+",
	"./tip-clock-dag.svg": "m1w2",
	"./tip-exercise-dag.svg": "6e6b",
	"./tip-food-dag.svg": "taMl",
	"./tip-general-dag.svg": "kB6C",
	"./tip-sleep-dag.svg": "7Pl0",
	"./tosti-day.svg": "EPMq",
	"./tosti-morning.svg": "y+U6",
	"./tosti-night.svg": "hYL5",
	"./vegetables-day.svg": "CRdG",
	"./vegetables-morning.svg": "GPgY",
	"./vegetables-night.svg": "0OPN",
	"./wrap-day.svg": "nZq8",
	"./wrap-morning.svg": "c6DS",
	"./wrap-night.svg": "lhJ+",
	"./yoghurt-day.svg": "zyox",
	"./yoghurt-morning.svg": "00oY",
	"./yoghurt-night.svg": "h6++"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uJgR";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Food icons ^\.\/.*$
// module id = uJgR
// module chunks = 0